module.exports = __webpack_public_path__ + "img/Visa_Inc._logo.svg.bc4c4fd3.png";